import { render, staticRenderFns } from "./BranchDialogGroups.vue?vue&type=template&id=9143a826&"
import script from "./BranchDialogGroups.vue?vue&type=script&lang=ts&"
export * from "./BranchDialogGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports